import { render } from "./UserEditPassword.vue?vue&type=template&id=c5a3ba14"
import script from "./UserEditPassword.vue?vue&type=script&lang=js"
export * from "./UserEditPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__